// extracted by mini-css-extract-plugin
export default {"editContainer":"EditableLabel_editContainer__2WTjo"};